<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-home"></i> 分支机构业务员管理
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
		<div class="handle-box">
			<el-button
			    type="primary"
			    icon="el-icon-circle-plus-outline"
			    class="handle-add"
			    @click="handleadd('addform')"
			>添加业务员账号</el-button>
		</div>
        <div class="container">
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
            >
                <el-table-column prop="name" label="姓名"></el-table-column>
                <el-table-column prop="identityCards" label="省份证号码"></el-table-column>
                <el-table-column prop="statusStr" label="状态" align="center"></el-table-column>
				<el-table-column prop="responsibleAreaStr" label="负责区域"></el-table-column>
                <el-table-column label="操作" width="100" align="center">
                    <template slot-scope="scope">
						<!-- <el-button
						    type="text"
						    icon="el-icon-view"
						    @click="handlsee(scope.row)"
						>查看</el-button> -->
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.row)"
                        >编辑</el-button>
                       <!-- <el-button
                            type="text"
                            icon="el-icon-delete"
                            @click="handleDelete(scope.row)"
                        >删除</el-button> -->
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
		<!-- 添加机构分支 -->
		<el-dialog class="branch-dialog" title="添加业务员账号" :visible.sync="addVisible" width="600px">
		    <el-form ref="addform" :model="addform" :rules="addrules">
		        <el-form-item label="姓名" prop="name">
		            <el-input v-model="addform.name"></el-input>
		        </el-form-item>
		        <el-form-item label="电话" prop="cellphoneNumber">
		            <el-input v-model="addform.cellphoneNumber"></el-input>
		        </el-form-item>
				<el-form-item label="身份证号" prop="identityCards">
				    <el-input v-model="addform.identityCards"></el-input>
				</el-form-item>
				<!-- 负责区域 -->
				<p class="branch-area">
					<span>负责区域</span>
					<i @click="cityAdd()" class="el-icon-circle-plus-outline" style="color: #409EFF;"></i>
				</p>
				<el-form-item
					class="branch-areaitem"
					v-for="(domain, index) in addform.domains"
					:key="index"
					:prop="'domains.' + index"
					:rules="{
					  required: true, message: '区域不能为空', trigger: 'change'
					}"
				  >
					<el-cascader :options="cityList" :props="optionProps" v-model="addform.domains[index]"></el-cascader>
					<b  v-if="index>0" class="el-icon-delete" style="color: #409EFF;" @click="citydelete(domain)"></b>
				  </el-form-item>
								 
				<el-form-item label="状态">
				    <el-radio-group v-model="addform.status">
				        <el-radio label="1">在职</el-radio>
				        <el-radio label="2">离职</el-radio>
				    </el-radio-group>
				</el-form-item>
		    </el-form>
			
		    <span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="saveAdd('addform')">确 定</el-button>
		        <el-button @click="addVisible = false">取 消</el-button>
		    </span>
		</el-dialog>
		
		
        <!-- 编辑弹出框 -->
        <el-dialog class="branch-dialog" title="编辑分支机构" :visible.sync="editVisible" width="600px">
            <el-form ref="editform" :model="editform" :rules="editrules">
            	<el-form-item label="姓名" prop="name">
            	    <el-input v-model="editform.name"></el-input>
            	</el-form-item>
            	<el-form-item label="电话" prop="cellphoneNumber">
            	    <el-input v-model="editform.cellphoneNumber"></el-input>
            	</el-form-item>
            	<el-form-item label="身份证号" prop="identityCards">
            	    <el-input v-model="editform.identityCards"></el-input>
            	</el-form-item>
				<p class="branch-area">
					<span>负责区域</span>
					<i @click="cityAddedit()" class="el-icon-circle-plus-outline" style="color: #409EFF;"></i>
				</p>
            	<el-form-item
            		class="branch-areaitem"
            		v-for="(domain, index) in editform.domains"
            		:key="index"
            		:prop="'domains.' + index"
            		:rules="{
            		  required: true, message: '区域不能为空', trigger: 'change'
            		}"
            	  >
            		<el-cascader :options="cityList" :props="optionProps" v-model="editform.domains[index]"></el-cascader>
            		<b  v-if="index>0" class="el-icon-delete" style="color: #409EFF;" @click="citydeleteedit(domain)"></b>
            	  </el-form-item>
            	
            	<el-form-item label="状态" prop="status">
            	    <el-radio-group v-model="editform.status">
            	        <el-radio label="1">在职</el-radio>
            	        <el-radio label="2">离职</el-radio>
            	    </el-radio-group>
            	</el-form-item>
            </el-form>
            
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit('editform')">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>




<script>
import {listBranchBusinessPersons,saveBranchBusinessPerson,getBranchBusinessPerson,updateBranchBusinessPerson,listProvinceCitys } from '@/api/index';// 导入我们的api接口

export default {
    name: 'fzorganadmin',
    data() {
		var validPhone = (rule, value, callback) => {
					  // debugger
		       const phoneReg = /^[1](([3][0-9])|([4][0,1,4-9])|([5][0-3,5-9])|([6][2,5,6,7])|([7][0-8])|([8][0-9])|([9][0-3,5-9]))[0-9]{8}$/
		       if (!value) {
		         return callback(new Error('电话号码不能为空'))
		       }else if(!Number.isInteger(+value)) {
		           callback(new Error('请输入数字值'))
		       } else {
		           if (phoneReg.test(value)) {
		             callback()
		        } else {
		             callback(new Error('电话号码格式不正确'))
		           }
		         }
		};
		var validIdNum = (rule, value, callback) => {
		  const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
		  if (!value) {
		    return callback(new Error('证件号码不能为空'))
		  } else if (!reg.test(value)) {
		    return callback(new Error('证件号码不正确'))
		  } else {
		    callback()
		  }
		};
        return {
			cityList:[],//省市数据
			optionProps: {
					value: 'id',
					label: 'name'
			},   //省市联动重命名指向
            query: {
                pageIndex: 1,
                pageSize: 10
            },   //分页
			pageTotal: 0,  //数据总条数
            tableData: [],  //列表数据
			addform:{
				name:'',
			    cellphoneNumber:'',
				identityCards:'',
				domains: [[]],  //负责区域中间量
				responsibleArea:[],  //负责区域提交量
				status:'1'
			},    //添加机构分支表单
			addrules: {
				  name: [
					{ required: true, message: '请输入分支机构名称', trigger: 'blur' }
				  ],
				 
				 cellphoneNumber:[
				 					{ required: true, trigger: 'blur', validator: validPhone }//这里需要用到全局变量
				 ],
				  identityCards:[
				 	{ required: true, trigger: 'blur', validator: validIdNum }
				 ],
				  
				},  //添加表单验证
				// editform:{},
			domainsedit: [],
			editform:{
				domains: [],  //负责区域中间量
			},   //编辑表单
			editrules: {
				  name: [
				  					{ required: true, message: '请输入分支机构名称', trigger: 'blur' }
				  ],
				  cellphoneNumber:[
				  					{ required: true, trigger: 'blur', validator: validPhone }//这里需要用到全局变量
				  ],
				   identityCards:[
				  	{ required: true, trigger: 'blur', validator: validIdNum }
				  ],
				 
				  
				},  //添加表单验证
			
			addVisible:false,  //添加分支机构
            editVisible: false, //编辑分支机构
			
            
			
        };
    },
    created() {
		var that = this;
		// 列表数据
		this.getlistBranchOrganizations();
		listProvinceCitys({
		}).then(res => {
		    // 获取数据成功后的其他操作
			that.cityList = res.data;
		})
		
    },
    methods: {
		// 获取列表数据
		getlistBranchOrganizations(){
			listBranchBusinessPersons({
				current: this.query.pageIndex,                    
				size: this.query.pageSize              
			}).then(res => {
				// 获取数据成功后的其他操作
				if(res.code == 0){
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				}
				
			});
		},
		//点击添加按钮事件
		handleadd(formName){
			this.addVisible = true;
			
			this.addform.domains = [[]];
			//重置表单数据
			this.$nextTick(()=>{
			  this.$refs.[formName].resetFields();
			})
		},
		// 添加保存
		saveAdd(formName) {
			this.$refs[formName].validate((valid) => {
			  if (valid) {
				  // 字段处理
				  // 负责区域字段格式处理
				  var responsibleArea = [];
				  console.log(this.addform.domains)
				  for(var i in this.addform.domains){
				  	if(this.addform.domains[i]){
				  		responsibleArea.push(this.addform.domains[i].join(','));
				  	}
				  }
				  this.addform.responsibleArea = JSON.stringify(responsibleArea);
				  console.log(this.addform.responsibleArea)
				
				
				  
				  saveBranchBusinessPerson(this.addform).then(res => {
					  this.getlistBranchOrganizations();
					  if(res.code == 0){
						  // 获取数据成功后的其他操作
							this.$message({
							  message: res.message,
							  type: 'success'
							});
							this.addVisible = false;
					  }else if(res.code == 1){
						  this.$message({
						    message: res.message,
						    type: 'warning'
						  });
					  }else{
						  this.$message({
						    message: '报错啦!',
						    type: 'warning'
						  });
					  }
					   
				  });
			  } else {
				return false;
			  }
			});
		  },
		
		// 省市联动增加
		cityAdd() {
			console.log(this.addform.domains)
		  this.addform.domains.push([]);
		},
		//省市联动删除
       citydelete(item) {
		   console.log(item)
		   var that = this;
		   var index = this.addform.domains.indexOf(item)
		   if (index !== -1) {
			 this.addform.domains.splice(index, 1)
		   }
		 },
        // 编辑操作
        handleEdit(row) {
			this.domainsedit = [];
			this.editVisible = true;
			getBranchBusinessPerson({},{
						 "personId": row.personId              
			}).then(res => {
				  // 获取数据成功后的其他操作
				  this.editform = res.data;  
				  this.editform.status = res.data.status + '';
				  
				  var responsibleAreazjl = JSON.parse(this.editform.responsibleArea);
				  for(var i in responsibleAreazjl){
						  var domains1 = [];
						  var Areazjl1 = responsibleAreazjl[i];
						  var Areazjl2 = Areazjl1.split(',')
						  domains1 = [parseInt(Areazjl2[0]),parseInt(Areazjl2[1])];
						  this.domainsedit.push(domains1);
				  }
				  this.$set(this.editform, 'domains', this.domainsedit)
						
			});
			
			
			
        },
		
		// 省市联动增加
		cityAddedit() {
			// debugger
			var that = this;
			that.editform.domains.push([]);
		},
				//省市联动删除
		citydeleteedit(item) {
			
			console.log(item)
			var that =  this;
				   var index = that.editform.domains.indexOf(item)
				   if (index !== -1) {
					 that.editform.domains.splice(index, 1)
				   }
		},
		
        // 保存编辑
        saveEdit(formName) {
			console.log(formName);
			this.$refs[formName].validate((valid) => {
			  if (valid) {
				  // 字段处理
				  // 负责区域字段格式处理
				  var responsibleArea = [];
				  console.log(this.editform.domains)
				  for(var i in this.editform.domains){
				  	if(this.editform.domains[i]){
				  		responsibleArea.push(this.editform.domains[i].join(','));
				  	}
				  }
				  this.editform.responsibleArea = JSON.stringify(responsibleArea);
				  console.log(this.editform.responsibleArea)
				 
				  
				  updateBranchBusinessPerson(this.editform).then(res => {
					  this.getlistBranchOrganizations();
					  if(res.code == 0){
						  // 获取数据成功后的其他操作
							this.$message({
							  message: res.message,
							  type: 'success'
							});
							this.editVisible = false;
					  }else if(res.code == 1){
						  this.$message({
						    message: res.message,
						    type: 'warning'
						  });
					  }else{
						  this.$message({
						    message: '报错啦!',
						    type: 'warning'
						  });
					  }
					   
				  });
			  } else {
				return false;
			  }
			});
			
			
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getlistBranchOrganizations();
        }
    }
};
</script>

<style scoped>
.handle-box {
	height: 32px;
	line-height: 32px;
    margin-bottom: 20px;
}
.handle-add{
	float: right;
}
.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

/* 弹框样式 */
.branch-dialog-title{
	border-left: 4px solid #409EFF;
	font-size: 16px;
	text-indent: 10px;
	margin-bottom: 20px;
}

.see-list p{
	/* line-height: 32px; */
	margin-bottom: 20px;
	letter-spacing: 1px;
	font-size: 14px;
	text-indent: 15px;
}



</style>
<style>
.branch-dialog	.el-dialog__header{
	background:#409EFF;
	padding: 10px 20px;
}
.branch-dialog	.el-dialog__header	.el-dialog__title{
	color: #fff;
}
.branch-dialog	.el-dialog__header .el-dialog__headerbtn{
	background:#409EFF;
	top: 12px;
}
.branch-dialog	.el-dialog__header .el-dialog__headerbtn .el-dialog__close{
	color: #fff;
	font-size: 20px;
}
.branch-dialog .el-dialog__body{
	height:50vh;
	overflow-y: scroll;
	padding: 20px 20px 30px;
}
.branch-dialog .el-form-item__label{
	/* text-align: left; */
	width: 130px;
}
.branch-dialog .el-form-item__content{
	margin-left: 130px;
}

.branch-area{
	position: relative;
	height:32px;
	line-height: 32px;
	margin-bottom: 4px;
}
.branch-area span{
	display: block;
	width:118px;
	text-align: right;
}
.branch-area span::before{
	content: '*';
	color: #F56C6C;
	margin-right: 4px;
}
.branch-area i{
	position: absolute;
	top: 7px;
	right: 0;
	font-size: 20px;
	cursor: pointer;
}
.branch-areaitem{
	position: relative;
}
.branch-areaitem .el-cascader{
	width: 90%;
}
.branch-areaitem b{
	position: absolute;
	top: 7px;
	right: 0;
	font-size: 20px;
	cursor: pointer;
}
.branch-password .el-form-item__label::before{
	content: '*';
	color: #F56C6C;
	margin-right: 4px;
}
</style>
